import styles from './styles.module.css';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// personal components
import HeroSection from '../../componentes/HeroSection';
import FeaturesSection from '../../componentes/FeaturesSection';
import Planos from '../basicPlans';
import Testimonials from '../../componentes/Testimonials';
//import FAQ from '../../componentes/depoimentos';
import CTA from '../../componentes/CTA';
import Carrossel from '../../componentes/carrossel';

function Home(){
    return(
        <section className={styles.main}>
            <Helmet>
                <title>Orçamento Digital — Sistema de Orçamento e Notas de Serviço Online</title>
                <meta
                    name="description"
                    content="Crie orçamentos e notas de serviço profissionais em minutos. Sistema online e no celular, com controle de estoque, PDF automático e cobrança recorrente."
                />
                <link rel="canonical" href="https://www.orcamento-digital.com" />
                <meta property="og:title" content="Orçamento Digital — Sistema de Orçamento Online" />
                <meta property="og:description" content="Crie orçamentos e notas de serviço profissionais em minutos, direto do navegador ou do celular." />
                <meta property="og:url" content="https://www.orcamento-digital.com" />
            </Helmet>
            <HeroSection />
            <FeaturesSection />
            <Planos />
            {/*<Testimonials />*/}
            <Carrossel/>
            <CTA />
            {/*<FAQ />*/}
        </section>
        
        
    )
}

export default Home;